import { Admin } from '../pages/Admin/Admin';
import { ForgotLogin } from '../pages/ForgotLogin/ForgotLogin';
import { Login } from '../pages/Login/Login';
import { SignUp } from '../pages/SignUp/SignUp';
import { EaterGroupAdmin } from '../pages/EaterGroupAdmin/EaterGroupAdmin';
import { ResetPassword } from '../pages/ResetPassword/ResetPassword';
import { BookingPage } from '../pages/BookingPage/BookingPage';
import { Error404 } from '../pages/Error404/Error404';
import { SysAdminPage } from '../pages/SysAdminPages/SysAdminPage';
import { IRoute } from '../interface/interface';
import { VerifyUser } from '../pages/VerifyUser/VerifyUser';
import { SignUpInfo } from '../pages/SignUpInfo/SignUpInfo';
import { Profile } from '../pages/Profile/Profile';
import { Onboarding } from '../pages/Onboarding/Onboarding';
import { OnboardingVerification } from '../pages/OnboardingVerification/OnboardingVerification';

const routes: IRoute[] = [
    {
        path: '/',
        name: 'Login Page',
        component: Login,
        exact: true,
        roleRequired: ''
    },
    {
        path: '/signUp',
        name: 'Sign up Page',
        component: SignUp,
        exact: true,
        roleRequired: ''
    },
    {
        path: '/verify/:email/:token',
        name: 'Verify user Page',
        component: VerifyUser,
        exact: true,
        roleRequired: ''
    },
    {
        path: '/signUpInfo',
        name: 'Sign up info Page',
        component: SignUpInfo,
        exact: true,
        roleRequired: ''
    },
    {
        path: '/booking',
        name: 'Booking Page',
        component: BookingPage,
        exact: true,
        roleRequired: 'eater_users'
    },
    {
        path: '/profile',
        name: 'Profile Page',
        component: Profile,
        exact: true,
        roleRequired: 'eater_users'
    },
    {
        path: '/admin',
        name: 'Admin Page',
        component: Admin,
        exact: false,
        roleRequired: 'kitchen_manager_users'
    },
    {
        path: '/forgotLogin',
        name: 'Forgot Login',
        component: ForgotLogin,
        exact: true,
        roleRequired: ''
    },
    {
        path: '/eaterGroupAdmin',
        name: 'Eater Group Admin',
        component: EaterGroupAdmin,
        exact: true,
        roleRequired: 'eater_group_admin_users'
    },
    {
        path: '/resetPassword/:token',
        name: 'Reset Password',
        component: ResetPassword,
        exact: false,
        roleRequired: 'eater_users'
    },
    {
        path: '/sysAdmin',
        name: 'System admin Page',
        component: SysAdminPage,
        exact: false,
        roleRequired: 'system_admin_users'
    },
    {
        path: '/onboarding',
        name: 'Onboarding Page',
        component: Onboarding,
        exact: true,
        roleRequired: 'system_admin_users'
    },
    {
        path: '/onboarding/verify/:email/:token',
        name: 'Onboarding verify Page',
        component: OnboardingVerification,
        exact: true,
        roleRequired: ''
    },
    {
        path: '',
        name: 'Error 404',
        component: Error404,
        exact: true,
        roleRequired: ''
    },
]

export default routes;